module.exports = __webpack_public_path__ + "static/media/option6.9fcba13d.png";